//接口地址
const basePath = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASEPATH : '/api';
// const basePath ="https://develop.wosaiapp.cn/api";//开发环境
// const basePath = "https://jkpj-qlc-web.guahao.cn/api/";//生产环境
//const basePath = process.env.VUE_APP_BASEPATH;

//设置项
const setting = {
  mockbasePath: "http://localhost:3000/",
  mockData: false,//是否使用mock数据
  basePath: basePath,//接口位置
  pageNum: 10, //分页每页记录数
  pageSizes: [10, 20, 50, 100,150,200],
  sysName: process.env.VUE_APP_TITLE,
  upLoadSize: 4,//上传文件大小限制（MB）超过分块上传
  timeout: 1200000,
}


//导航菜单
const menu = {
  OMSMenu: [
    // { id: "0101", name: "基础大模型", path: "/AIchat-base", menuIcon: "el-icon-s-opportunity" },
    { id: "0102", name: "增强大模型", path: "/AIchat-enhanced", menuIcon: "el-icon-star-on" },
    // {
    //   id: "0102", name: "基础数据管理", menuIcon: "fas fa-file-medical-alt", children: [
    //     { id: "010201", name: "学校管理", menuLink: "/home/school" },
    //     { id: "010202", name: "教师管理", menuLink: "/home/teacher" },
    //     { id: "010203", name: "班级管理", menuLink: "/home/stuClass" },
    //     { id: "010204", name: "学生管理", menuLink: "/home/student" },

    //     ]
    // },
       
        
  ]
  
}

export {
    setting,
    menu
};